import { t } from "../../../hooks/useAppTranslation";
import {useState} from 'react';
import {createPortal} from 'react-dom';

import PopUp from '../../PopUp/PopUp';
import {AddDocuments, DocumentsLists, JoinFiles} from '..';
import '../Documents.scss';


const $MODAL_CONTAINER = document.getElementById('modal-root');


const VIEWS_DICT = {
  basic: 'BASIC_VIEW',
  addFiles: 'ADD_FILES_VIEW',
  joinFiles: 'JOIN_FILES_VIEW',
};


export const Documents = ({
  controlUuid,
  disabled,
  endsWithAfterControlNote,
  excludedDocumentsIdsForJoining,
  excludeFromCurrentControl,
  hiddenButtons,
  inPopup,
  popUpTitle,
  projectUuid,
  removingOnListForbidden,  // if withDocumentsList, this one blocks removing from list
  withDocumentsList,
  onAddSuccess,
  onCancel,
  popupNotScrolled,
  saveAsDraft
}) => {
  const [selectedView, setSelectedView] = useState(VIEWS_DICT.basic);

  if (selectedView === VIEWS_DICT.addFiles) {
    return createPortal(
      <AddDocuments
        controlUuid={controlUuid}
        onClose={documentList => {
          documentList = documentList || [];
          setSelectedView(VIEWS_DICT.basic);
          onAddSuccess && onAddSuccess(documentList);
        }}
      saveAsDraft={saveAsDraft}/>,
      $MODAL_CONTAINER
    )
  }

  if (selectedView === VIEWS_DICT.joinFiles) {
    return createPortal(
      <JoinFiles
        controlUuid={controlUuid}
        excludedDocumentsIds={excludedDocumentsIdsForJoining}
        excludeFromCurrentControl={excludeFromCurrentControl}
        projectUuid={projectUuid}
        onCancel={() => setSelectedView(VIEWS_DICT.basic)}
        onJoin={documentList => {
          onAddSuccess && onAddSuccess(documentList);
          setSelectedView(VIEWS_DICT.basic);
        }}
      />,
      $MODAL_CONTAINER
    )
  }

  const content = (
    <>
      {!hiddenButtons &&
        <div className="row documents__buttons">
          <div className="col-6">
            <button
              className="btn save-btn"
              disabled={disabled}
              onClick={() => setSelectedView(VIEWS_DICT.addFiles)}
            >
              {t('g-add-file')}
            </button>
          </div>
          <div className="col-6">
            <button
              className="btn save-btn"
              disabled={disabled}
              onClick={() => setSelectedView(VIEWS_DICT.joinFiles)}
            >
              {t('g-link-file')}
            </button>
          </div>
        </div>
      }
      {withDocumentsList &&
        <DocumentsLists
          controlUuid={controlUuid}
          endsWithAfterControlNote={endsWithAfterControlNote}
          removingOnListForbidden={removingOnListForbidden}
        />
      }
    </>
  );

  if (inPopup) {
    return createPortal(
      <PopUp
          className="documents"
          customContent
          notification=""
          title={popUpTitle || 'Pliki'}
          handleClosePopup={onCancel}
          scrolled={!popupNotScrolled}
      >
        {content}
      </PopUp>,
        $MODAL_CONTAINER
    )
  }

  return content
};
